import dayjs from 'dayjs';
import { Dispute } from 'api/escrow/types';
import { DISPUTE_REASON_CODE_LABELS, DisputeReasonCodeEnum } from 'utils/enums';

type Props = { dispute: Dispute };

export default function DisputeInfo({ dispute }: Props) {
  const reasonLabel = DISPUTE_REASON_CODE_LABELS[dispute.reasonCode as DisputeReasonCodeEnum] ?? dispute.reasonCode;

  return (
    <div className="bg-brand-purple-card rounded-lg p-4 md:p-6">
      <h3 className="text-lg font-bold text-brand-black mb-4">Dispute Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <p className="text-xs text-gray-500">Reason</p>
          <p className="text-sm font-semibold text-brand-black">{reasonLabel}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Opened By</p>
          <p className="text-sm font-semibold text-brand-black">
            {dispute.openedBy?.username ?? 'Unknown'} ({dispute.openedByRole})
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Opened On</p>
          <p className="text-sm font-semibold text-brand-black">
            {dayjs(dispute.createdAt).format('MMM D, YYYY h:mm A')}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Stage</p>
          <p className="text-sm font-semibold text-brand-black capitalize">{dispute.stage}</p>
        </div>
      </div>
      {dispute.reasonText && (
        <div className="mt-3">
          <p className="text-xs text-gray-500">Description</p>
          <p className="text-sm text-brand-black mt-1 whitespace-pre-wrap">{dispute.reasonText}</p>
        </div>
      )}
    </div>
  );
}
